import { InjectionToken } from "@angular/core";
import { ILanguage } from "projects/shared/lib/interfaces/language/language.interface";

export interface ILanguageService {
  currentLocaleGet(): ILanguage | undefined;
  currentLocaleGetOrDefault(): ILanguage;
  configuredLanguageListGet(): ILanguage[];
}

/** Injection token which makes it possible to provide and inject the interface. */
// eslint-disable-next-line @typescript-eslint/naming-convention
export const ILanguageServiceToken = new InjectionToken<ILanguageService>('ILanguageServiceToken');
